import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../layout/Home/Home.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Filter from '../layout/Filter';
import Doctors from "./Doctors";
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import SearchIcon from '@mui/icons-material/Search';
import { fetchAPI } from "../utils/api";
import "../caregiver/nursingcare/NursingCare.css";
import { ShimmerThumbnail, ShimmerTitle, ShimmerButton } from "react-shimmer-effects";

function DoctorList() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [doctorsList, setDoctorsList] = useState([]);
  const [specializations, setSpecializations] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [consultationTypes, setConsultationTypes] = useState([]);
  const [daysList, setDaysList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  
  // Filter states
  const [selectedSpecialization, setSelectedSpecialization] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [selectedConsultationType, setSelectedConsultationType] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchInput, setSearchInput] = useState("");
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const q = params.get("search");
    if (q) {
      setSearchQuery(q);
      setSearchInput(q);
    }
  }, [location.search]);

  useEffect(() => {
    const loadFilters = async () => {
      try {
        const [specData, langData, consultData, daysData, citiesData] = await Promise.all([
          fetchAPI("DoctorController/specialization", { method: "GET" }),
          fetchAPI("DoctorController/languages", { method: "GET" }),
          fetchAPI("DoctorController/consultation_types", { method: "GET" }),
          fetchAPI("DoctorController/days", { method: "GET" }),
          fetchAPI("DoctorController/cities", { method: "GET" })
        ]);

        if (specData && specData.status === 200) {
          setSpecializations(specData.result || []);
        }
        if (langData && langData.status === 200) {
          setLanguages(langData.result || []);
        }
        if (consultData && consultData.status === 200) {
          setConsultationTypes(consultData.result || []);
        }
        if (daysData && daysData.status === 200) {
          setDaysList(daysData.result || []);
        }
        if (citiesData && citiesData.status === 200) {
          setCitiesList(citiesData.result || []);
        }
      } catch (err) {
        console.error("Error loading doctor filters:", err);
      }
    };

    loadFilters();
  }, []);

  // Fetch doctors dynamically based on filters & search
  useEffect(() => {
    const loadDoctors = async () => {
      try {
        setLoading(true);
        const data = await fetchAPI("DoctorController/doctors", {
          method: "POST",
          body: JSON.stringify({
            specialization_id: selectedSpecialization,
            language_id: selectedLanguage,
            consultation_type_id: selectedConsultationType,
            day_id: selectedDay,
            city_id: selectedCity,
            search: searchQuery
          })
        });

        if (data && data.status === 200) {
          setDoctorsList(data.result || []);
        } else {
          setDoctorsList([]);
        }
      } catch (err) {
        console.error("Error loading doctors list:", err);
        setError("Failed to load doctors list. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    loadDoctors();
  }, [selectedSpecialization, selectedLanguage, selectedConsultationType, selectedDay, selectedCity, searchQuery]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setSearchQuery(searchInput);
  };

  const handleClearAll = () => {
    setSelectedSpecialization("");
    setSelectedLanguage("");
    setSelectedConsultationType("");
    setSelectedDay("");
    setSelectedCity("");
    setSearchQuery("");
    setSearchInput("");
  };

  const activeSpec = specializations.find(
    (s) => String(s.specialization_id) === String(selectedSpecialization)
  );

  return (
    <>
      <Header />

      <div className="test_bredcum_sec">
        <div className="container-fluid">
          <div className="test_bredcum">
            <Link to="/">Home</Link>
            <span>&gt;</span>
            <Link to="/doctor-consultation-services">Doctors</Link>
            <span>&gt;</span>
            <span className='name_p'>
              {activeSpec ? activeSpec.specialization_name : "All Specialities"}
            </span>
          </div> 
        </div> 
      </div>

      <div className="dr_list_page">
        <div className="container-fluid">
          <div className="dr_list_iner">
            <div className="row">
              <div className="col-lg-3">
                <Filter 
                  open={open} 
                  setOpen={setOpen} 
                  isDoctorFilter={true}
                  consultationTypes={consultationTypes}
                  selectedConsultationType={selectedConsultationType}
                  onConsultationTypeChange={setSelectedConsultationType}
                  specializations={specializations}
                  selectedSpecialization={selectedSpecialization}
                  onSpecializationChange={setSelectedSpecialization}
                  languages={languages}
                  selectedLanguage={selectedLanguage}
                  onLanguageChange={setSelectedLanguage}
                  days={daysList}
                  selectedDay={selectedDay}
                  onDayChange={setSelectedDay}
                  cities={citiesList}
                  selectedCity={selectedCity}
                  onCityChange={setSelectedCity}
                  onClearAll={handleClearAll}
                />
              </div>
              <div className="col-lg-9">
                <div className="right_side_header_test">
                  <h3>Available Doctors ({doctorsList.length})</h3>
                        
                  <div className="search_bar_test">
                    <div className="main_serach_bar_test">
                      <form className="search-form_test dr_list_srh" onSubmit={handleSearchSubmit}>
                        <input 
                          type="search" 
                          placeholder="Search Doctors by Name or Qualification..." 
                          className="search_input" 
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                        />
                        <button type="submit" className="search_btn"> <SearchIcon /> </button>
                      </form>
                    </div>
                    <div className="filter_btn">
                      <button className="filter_btn" onClick={() => setOpen(true)}>
                        <TuneRoundedIcon />
                      </button>
                    </div>
                  </div>
                </div>

                <div className="doctor-list" style={{ marginTop: '20px' }}> 
                  {loading ? (
                    <div className="row g-3">
                      {[1, 2, 3, 4].map((n) => (
                        <div key={n} className="col-lg-6 col-md-6 col-sm-12 col-12">
                          <div className="p-3 bg-white border rounded shadow-sm">
                            <div className="d-flex gap-3 align-items-center mb-3">
                              <ShimmerThumbnail height={80} width={80} rounded />
                              <div className="flex-grow-1">
                                <ShimmerTitle line={2} gap={10} variant="subheading" />
                              </div>
                            </div>
                            <ShimmerButton size="md" />
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : error ? (
                    <div className="alert alert-danger text-center my-4">{error}</div>
                  ) : doctorsList.length === 0 ? (
                    <div className="text-center my-5">
                      <h4 className="text-muted">No doctors found matching the selected filters.</h4>
                      <button className="btn btn-primary mt-3" onClick={handleClearAll} style={{ backgroundColor: '#13baac', borderColor: '#13baac' }}>
                        Clear Filters
                      </button>
                    </div>
                  ) : (
                    <div className="row g-3">
                      {doctorsList.map((doc) => (
                        <div key={doc.doctor_id} className="col-lg-6 col-md-6 col-sm-12 col-12">
                          <Doctors doctor={doc} />
                        </div>
                      ))}
                    </div> 
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
}

export default DoctorList;
